module.exports = __webpack_public_path__ + "static/media/female-red-v3.aab153fb.svg";